<div class="container">
  <div class="row head">
    <div class="col-12">
      <span class="title" i18n="parameters-apiwebhook|@@title_api_key_and_webhook">Clefs APIs & WebHook</span>
    </div>
  </div>
  <div *ngIf="!isLoading" class="row">
    <div class="col-12 report-form">
      <span class="column-title" i18n="parameters-apiwebhook|@@title_APIs">APIs</span>
      <div class="container">
        <div class="row generalrows">
          <div class="col-3 center">
            <span class="span-txt" i18n="parameters-apiwebhook|@@public_key">Clefs publique</span>
          </div>
          <div class="col-6">
            <span *ngIf="!isLoadingPublic" class="span-key">
              {{publicKey}}
            </span>
            <div *ngIf="isLoadingPublic">
              <content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="330" [height]="40">
                <svg:rect id="rect3686" width="330px" height="40px" x="0" y="0" rx="3" ry="3"
                  style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
              </content-loader>
            </div>
          </div>
          <div class="col-3">
            <button *ngIf="hidePublic" type="button" class="btn btn-lg secondary" (click)="click('public')">
              <svg width="16px" height="16px" viewBox="0 0 16 12" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>eye</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Parametrage" transform="translate(-1067.000000, -3006.000000)" fill="#848484">
                    <g id="Content" transform="translate(150.000000, 103.000000)">
                      <g id="Group-2" transform="translate(298.000000, 2735.000000)">
                        <g id="eye-btn" transform="translate(603.000000, 158.000000)">
                          <g id="eye" transform="translate(16.000000, 10.000000)">
                            <path
                              d="M8,12 C12.707,12 15.744,6.716 15.871,6.492 C16.0423473,6.18789583 16.0427264,5.81645323 15.872,5.512 C15.746,5.287 12.731,0 8,0 C3.245,0 0.251,5.289 0.126,5.514 C-0.0429369167,5.81723244 -0.0421795203,6.18646319 0.128,6.489 C0.254,6.713 3.269,12 8,12 Z M8,2 C10.839,2 13.036,4.835 13.818,6 C13.034,7.166 10.837,10 8,10 C5.159,10 2.962,7.162 2.181,5.999 C2.958,4.835 5.146,2 8,2 Z"
                              id="Shape" fill-rule="nonzero"></path>
                            <circle id="Oval" cx="8" cy="6" r="2"></circle>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
            <button *ngIf="!hidePublic" type="button" class="btn btn-lg secondary" (click)="click('public')">
              <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>Shape</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Parametrage" transform="translate(-1067.000000, -2954.000000)" fill="#848484"
                    fill-rule="nonzero">
                    <g id="Content" transform="translate(150.000000, 103.000000)">
                      <g id="Group-2" transform="translate(298.000000, 2735.000000)">
                        <g id="eye-btn" transform="translate(603.000000, 108.000000)">
                          <g id="eye-close" transform="translate(16.000000, 8.000000)">
                            <path
                              d="M14.574,5.669 L13.15,7.093 C13.428,7.44 13.656,7.757 13.819,8 C13.059,9.13 10.969,11.82 8.258,11.985 L6.443,13.8 C6.939,13.924 7.457,14 8,14 C12.707,14 15.744,8.716 15.871,8.492 C16.0423473,8.18789583 16.0427264,7.81645323 15.872,7.512 C15.825,7.427 15.372,6.631 14.574,5.669 Z M0.293,15.707 C0.480135129,15.8952092 0.734590365,16.0010349 1,16.0010349 C1.26540963,16.0010349 1.51986487,15.8952092 1.707,15.707 L15.707,1.707 C16.0974653,1.31653468 16.0974653,0.683465318 15.707,0.293 C15.3165347,-0.0974653181 14.6834653,-0.0974653181 14.293,0.293 L11.548,3.038 C10.515,2.431 9.331,2 8,2 C3.245,2 0.251,7.289 0.126,7.514 C-0.0429369167,7.81723244 -0.0421795203,8.18646319 0.128,8.489 C0.198,8.614 1.172,10.291 2.821,11.765 L0.292,14.294 C0.104722311,14.4814896 -0.000388313677,14.7357067 -0.000200769118,15.0007071 C-1.32245582e-05,15.2657076 0.105457121,15.5197757 0.293,15.707 Z M2.181,7.999 C2.958,6.835 5.146,4 8,4 C8.742,4 9.437,4.201 10.078,4.508 L8.512,6.074 C8.34544024,6.02640895 8.17321882,6.00151757 8,6 C6.8954305,6 6,6.8954305 6,8 C6,8.178 6.029,8.348 6.074,8.512 L4.24,10.346 C3.45904071,9.65203252 2.76740147,8.86365114 2.181,7.999 Z"
                              id="Shape"></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
            <button type="button" class="btn btn-lg secondary" (click)="click('newPublic')">
              <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>Shape</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Parametrage" transform="translate(-1129.000000, -2953.000000)" fill="#848484"
                    fill-rule="nonzero">
                    <g id="Content" transform="translate(150.000000, 103.000000)">
                      <g id="Group-2" transform="translate(298.000000, 2735.000000)">
                        <g id="refresh-btn" transform="translate(665.000000, 107.000000)">
                          <g id="refresh" transform="translate(16.000000, 8.000000)">
                            <path
                              d="M8,3 C9.179,3 10.311,3.423 11.205,4.17 L8.883,6.492 L15.094,7.031 L14.555,0.82 L12.625,2.75 C11.346905,1.62453622 9.70299416,1.00251588 8,1 C4.57986746,0.989236013 1.65646558,3.45991927 1.097,6.834 L3.07,7.165 C3.46968486,4.7555914 5.55767996,2.99159554 8,3 Z M8,13 C6.82759214,12.9974996 5.69328309,12.5834148 4.795,11.83 L7.117,9.508 L0.906,8.969 L1.445,15.18 L3.375,13.25 C4.65309496,14.3754638 6.29700584,14.9974841 8,15 C11.4201325,15.010764 14.3435344,12.5400807 14.903,9.166 L12.93,8.835 C12.5303151,11.2444086 10.44232,13.0084045 8,13 Z"
                              id="Shape"></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
          </div>
        </div>
        <div class="row generalrows">
          <div class="col-3 center">
            <span class="span-txt" i18n="parameters-apiwebhook|@@private_key">Clefs privé</span>
          </div>
          <div class="col-6">
            <span *ngIf="!isLoadingPrivate" class="span-key">
              {{privateKey}}
            </span>
            <div *ngIf="isLoadingPrivate">
              <content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="330" [height]="40">
                <svg:rect id="rect3686" width="330px" height="40px" x="0" y="0" rx="3" ry="3"
                  style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
              </content-loader>
            </div>
          </div>
          <div class="col-3">
            <button *ngIf="hidePrivate" type="button" class="btn btn-lg secondary" (click)="click('private')">
              <svg width="16px" height="16px" viewBox="0 0 16 12" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>eye</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Parametrage" transform="translate(-1067.000000, -3006.000000)" fill="#848484">
                    <g id="Content" transform="translate(150.000000, 103.000000)">
                      <g id="Group-2" transform="translate(298.000000, 2735.000000)">
                        <g id="eye-btn" transform="translate(603.000000, 158.000000)">
                          <g id="eye" transform="translate(16.000000, 10.000000)">
                            <path
                              d="M8,12 C12.707,12 15.744,6.716 15.871,6.492 C16.0423473,6.18789583 16.0427264,5.81645323 15.872,5.512 C15.746,5.287 12.731,0 8,0 C3.245,0 0.251,5.289 0.126,5.514 C-0.0429369167,5.81723244 -0.0421795203,6.18646319 0.128,6.489 C0.254,6.713 3.269,12 8,12 Z M8,2 C10.839,2 13.036,4.835 13.818,6 C13.034,7.166 10.837,10 8,10 C5.159,10 2.962,7.162 2.181,5.999 C2.958,4.835 5.146,2 8,2 Z"
                              id="Shape" fill-rule="nonzero"></path>
                            <circle id="Oval" cx="8" cy="6" r="2"></circle>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
            <button *ngIf="!hidePrivate" type="button" class="btn btn-lg secondary" (click)="click('private')">
              <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>Shape</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Parametrage" transform="translate(-1067.000000, -2954.000000)" fill="#848484"
                    fill-rule="nonzero">
                    <g id="Content" transform="translate(150.000000, 103.000000)">
                      <g id="Group-2" transform="translate(298.000000, 2735.000000)">
                        <g id="eye-btn" transform="translate(603.000000, 108.000000)">
                          <g id="eye-close" transform="translate(16.000000, 8.000000)">
                            <path
                              d="M14.574,5.669 L13.15,7.093 C13.428,7.44 13.656,7.757 13.819,8 C13.059,9.13 10.969,11.82 8.258,11.985 L6.443,13.8 C6.939,13.924 7.457,14 8,14 C12.707,14 15.744,8.716 15.871,8.492 C16.0423473,8.18789583 16.0427264,7.81645323 15.872,7.512 C15.825,7.427 15.372,6.631 14.574,5.669 Z M0.293,15.707 C0.480135129,15.8952092 0.734590365,16.0010349 1,16.0010349 C1.26540963,16.0010349 1.51986487,15.8952092 1.707,15.707 L15.707,1.707 C16.0974653,1.31653468 16.0974653,0.683465318 15.707,0.293 C15.3165347,-0.0974653181 14.6834653,-0.0974653181 14.293,0.293 L11.548,3.038 C10.515,2.431 9.331,2 8,2 C3.245,2 0.251,7.289 0.126,7.514 C-0.0429369167,7.81723244 -0.0421795203,8.18646319 0.128,8.489 C0.198,8.614 1.172,10.291 2.821,11.765 L0.292,14.294 C0.104722311,14.4814896 -0.000388313677,14.7357067 -0.000200769118,15.0007071 C-1.32245582e-05,15.2657076 0.105457121,15.5197757 0.293,15.707 Z M2.181,7.999 C2.958,6.835 5.146,4 8,4 C8.742,4 9.437,4.201 10.078,4.508 L8.512,6.074 C8.34544024,6.02640895 8.17321882,6.00151757 8,6 C6.8954305,6 6,6.8954305 6,8 C6,8.178 6.029,8.348 6.074,8.512 L4.24,10.346 C3.45904071,9.65203252 2.76740147,8.86365114 2.181,7.999 Z"
                              id="Shape"></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
            <button type="button" class="btn btn-lg secondary" (click)="click('newPrivate')">
              <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>Shape</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Parametrage" transform="translate(-1129.000000, -2953.000000)" fill="#848484"
                    fill-rule="nonzero">
                    <g id="Content" transform="translate(150.000000, 103.000000)">
                      <g id="Group-2" transform="translate(298.000000, 2735.000000)">
                        <g id="refresh-btn" transform="translate(665.000000, 107.000000)">
                          <g id="refresh" transform="translate(16.000000, 8.000000)">
                            <path
                              d="M8,3 C9.179,3 10.311,3.423 11.205,4.17 L8.883,6.492 L15.094,7.031 L14.555,0.82 L12.625,2.75 C11.346905,1.62453622 9.70299416,1.00251588 8,1 C4.57986746,0.989236013 1.65646558,3.45991927 1.097,6.834 L3.07,7.165 C3.46968486,4.7555914 5.55767996,2.99159554 8,3 Z M8,13 C6.82759214,12.9974996 5.69328309,12.5834148 4.795,11.83 L7.117,9.508 L0.906,8.969 L1.445,15.18 L3.375,13.25 C4.65309496,14.3754638 6.29700584,14.9974841 8,15 C11.4201325,15.010764 14.3435344,12.5400807 14.903,9.166 L12.93,8.835 C12.5303151,11.2444086 10.44232,13.0084045 8,13 Z"
                              id="Shape"></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 report-form">
      <span class="column-title" i18n="parameters-apiwebhook|@@title_webhook">WebHook</span>
      <div class="container">
        <form [formGroup]="webhookForm">
          <div class="row generalrows">
            <div class="col-4 center">
              <span class="span-txt" i18n="parameters-apiwebhook|@@url">Url</span>
            </div>
            <div class="col-7">
              <input type="text" placeholder="https://domaine.com/etc..." formControlName="webhook">
            </div>
          </div>
          <div class="row generalrows">
            <div class="col-4 center">
              <span class="span-txt" i18n="parameters-apiwebhook|@@header_key">Header Key</span>
            </div>
            <div class="col-7">
              <input type="text" placeholder="AccessKey" formControlName="headerKey">
            </div>
          </div>

          <div class="row generalrows">
            <div class="col-12 ">
              <div class="allcheckbox">
                <label class="checkbox-container">
                  <input type="checkbox" name="newTchek" id="newTchek" formControlName="newTchek">
                  <span class="checkmark"></span><span i18n="parameters-apiwebhook|@@new_tchek">Nouveau
                    tchek</span></label>
                <label class="checkbox-container">
                  <input type="checkbox" name="detectionFinished" id="detectionFinished"
                    formControlName="detectionFinished">
                  <span class="checkmark"></span><span i18n="parameters-apiwebhook|@@detection_finished">Detection
                    terminée</span></label>
                <label class="checkbox-container">
                  <input type="checkbox" name="detectionFinishedCloud" id="detectionFinishedCloud"
                    formControlName="detectionFinishedCloud">
                  <span class="checkmark"></span><span i18n="parameters-apiwebhook|@@detection_finished_cloud">Detection
                    terminée (cloud)</span></label>
                <label class="checkbox-container">
                  <input type="checkbox" name="croppedImages" id="croppedImages" formControlName="croppedImages">
                  <span class="checkmark"></span><span i18n="parameters-apiwebhook|@@croppedImages">(option : Zoom Sur
                    Images)</span></label>
                <label class="checkbox-container">
                  <input type="checkbox" name="multiplePictureDamage" id="multiplePictureDamage"
                    formControlName="multiplePictureDamage">
                  <span class="checkmark"></span><span i18n="parameters-apiwebhook|@@multiplePictureDamage">(option :
                    Envoyer 3 images par dommage)</span></label>
              </div>
            </div>
          </div>

          <div class="row generalrows">
            <div class="col-12 ">
              <div class="allcheckbox">
                <label class="checkbox-container">
                  <input type="checkbox" name="sendToSI" id="sendToSI" formControlName="sendToSI">
                  <span class="checkmark"></span><span i18n="parameters-apiwebhook|@@send_to_si">Notifier
                    SI</span></label>
                <label class="checkbox-container">
                  <input type="checkbox" name="webhookPdf" id="webhookPdf" formControlName="webhookPdf">
                  <span class="checkmark"></span><span i18n="parameters-apiwebhook|@@webhookPdf"> Création du
                    PDF</span></label>
                <label class="checkbox-container">
                  <input type="checkbox" name="webhookPdfCloud" id="webhookPdfCloud" formControlName="webhookPdfCloud">
                  <span class="checkmark"></span><span i18n="parameters-apiwebhook|@@webhookPdfCloud"> Création du
                    PDF (Cloud)</span></label>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="col-12 report-form">
      <span class="column-title" i18n="parameters-apiwebhook|@@title_test_webhook">Test WebHook</span>
      <div class="container">
        <div class="row generalrows">
          <div class="col-3 center">
            <span class="span-txt" i18n="parameters-apiwebhook|@@event_type">Type d'évènement</span>
          </div>
          <div class="col-7">
            <ng-select [items]="typeValue" [bindLabel]="'value'" [bindValue]="'key'"
              [(ngModel)]="newValueSelectTestOption" [virtualScroll]='true' [searchable]='false' notFoundText="---"
              [clearable]='false' placeholder='---'>
            </ng-select>
          </div>
          <div class="col-2">
            <button type="button" class="btn btn-lg secondary" (click)="testWebhook()">
              <span i18n="parameters-apiwebhook|@@test_webhook" class="text-span">Tester</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>



  <div *ngIf="isLoading" class="row">
    <div class="col-12 report-form">
      <span class="column-title">APIs</span>
      <div class="container">
        <div class="row generalrows">
          <div class="col-3 center">
            <span i18n="parameters-apiwebhook|@@api_key" class="span-txt">Clefs publique</span>
          </div>
          <div class="col-6">
            <content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="330" [height]="40">
              <svg:rect id="rect3686" width="330px" height="40px" x="0" y="0" rx="3" ry="3"
                style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
            </content-loader>
          </div>
          <div class="col-3">
            <button *ngIf="hidePublic" type="button" class="btn btn-lg secondary" (click)="click('public')">
              <svg width="16px" height="16px" viewBox="0 0 16 12" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>eye</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Parametrage" transform="translate(-1067.000000, -3006.000000)" fill="#848484">
                    <g id="Content" transform="translate(150.000000, 103.000000)">
                      <g id="Group-2" transform="translate(298.000000, 2735.000000)">
                        <g id="eye-btn" transform="translate(603.000000, 158.000000)">
                          <g id="eye" transform="translate(16.000000, 10.000000)">
                            <path
                              d="M8,12 C12.707,12 15.744,6.716 15.871,6.492 C16.0423473,6.18789583 16.0427264,5.81645323 15.872,5.512 C15.746,5.287 12.731,0 8,0 C3.245,0 0.251,5.289 0.126,5.514 C-0.0429369167,5.81723244 -0.0421795203,6.18646319 0.128,6.489 C0.254,6.713 3.269,12 8,12 Z M8,2 C10.839,2 13.036,4.835 13.818,6 C13.034,7.166 10.837,10 8,10 C5.159,10 2.962,7.162 2.181,5.999 C2.958,4.835 5.146,2 8,2 Z"
                              id="Shape" fill-rule="nonzero"></path>
                            <circle id="Oval" cx="8" cy="6" r="2"></circle>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
            <button *ngIf="!hidePublic" type="button" class="btn btn-lg secondary" (click)="click('public')">
              <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>Shape</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Parametrage" transform="translate(-1067.000000, -2954.000000)" fill="#848484"
                    fill-rule="nonzero">
                    <g id="Content" transform="translate(150.000000, 103.000000)">
                      <g id="Group-2" transform="translate(298.000000, 2735.000000)">
                        <g id="eye-btn" transform="translate(603.000000, 108.000000)">
                          <g id="eye-close" transform="translate(16.000000, 8.000000)">
                            <path
                              d="M14.574,5.669 L13.15,7.093 C13.428,7.44 13.656,7.757 13.819,8 C13.059,9.13 10.969,11.82 8.258,11.985 L6.443,13.8 C6.939,13.924 7.457,14 8,14 C12.707,14 15.744,8.716 15.871,8.492 C16.0423473,8.18789583 16.0427264,7.81645323 15.872,7.512 C15.825,7.427 15.372,6.631 14.574,5.669 Z M0.293,15.707 C0.480135129,15.8952092 0.734590365,16.0010349 1,16.0010349 C1.26540963,16.0010349 1.51986487,15.8952092 1.707,15.707 L15.707,1.707 C16.0974653,1.31653468 16.0974653,0.683465318 15.707,0.293 C15.3165347,-0.0974653181 14.6834653,-0.0974653181 14.293,0.293 L11.548,3.038 C10.515,2.431 9.331,2 8,2 C3.245,2 0.251,7.289 0.126,7.514 C-0.0429369167,7.81723244 -0.0421795203,8.18646319 0.128,8.489 C0.198,8.614 1.172,10.291 2.821,11.765 L0.292,14.294 C0.104722311,14.4814896 -0.000388313677,14.7357067 -0.000200769118,15.0007071 C-1.32245582e-05,15.2657076 0.105457121,15.5197757 0.293,15.707 Z M2.181,7.999 C2.958,6.835 5.146,4 8,4 C8.742,4 9.437,4.201 10.078,4.508 L8.512,6.074 C8.34544024,6.02640895 8.17321882,6.00151757 8,6 C6.8954305,6 6,6.8954305 6,8 C6,8.178 6.029,8.348 6.074,8.512 L4.24,10.346 C3.45904071,9.65203252 2.76740147,8.86365114 2.181,7.999 Z"
                              id="Shape"></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
            <button type="button" class="btn btn-lg secondary" (click)="click('newPublic')">
              <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>Shape</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Parametrage" transform="translate(-1129.000000, -2953.000000)" fill="#848484"
                    fill-rule="nonzero">
                    <g id="Content" transform="translate(150.000000, 103.000000)">
                      <g id="Group-2" transform="translate(298.000000, 2735.000000)">
                        <g id="refresh-btn" transform="translate(665.000000, 107.000000)">
                          <g id="refresh" transform="translate(16.000000, 8.000000)">
                            <path
                              d="M8,3 C9.179,3 10.311,3.423 11.205,4.17 L8.883,6.492 L15.094,7.031 L14.555,0.82 L12.625,2.75 C11.346905,1.62453622 9.70299416,1.00251588 8,1 C4.57986746,0.989236013 1.65646558,3.45991927 1.097,6.834 L3.07,7.165 C3.46968486,4.7555914 5.55767996,2.99159554 8,3 Z M8,13 C6.82759214,12.9974996 5.69328309,12.5834148 4.795,11.83 L7.117,9.508 L0.906,8.969 L1.445,15.18 L3.375,13.25 C4.65309496,14.3754638 6.29700584,14.9974841 8,15 C11.4201325,15.010764 14.3435344,12.5400807 14.903,9.166 L12.93,8.835 C12.5303151,11.2444086 10.44232,13.0084045 8,13 Z"
                              id="Shape"></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
          </div>
        </div>
        <div class="row generalrows">
          <div class="col-3 center">
            <span i18n="parameters-apiwebhook|@@private_key" class="span-txt">Clefs privé</span>
          </div>
          <div class="col-6">
            <content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="330" [height]="40">
              <svg:rect id="rect3686" width="330px" height="40px" x="0" y="0" rx="3" ry="3"
                style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
            </content-loader>
          </div>
          <div class="col-3">
            <button *ngIf="hidePrivate" type="button" class="btn btn-lg secondary" (click)="click('private')">
              <svg width="16px" height="16px" viewBox="0 0 16 12" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>eye</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Parametrage" transform="translate(-1067.000000, -3006.000000)" fill="#848484">
                    <g id="Content" transform="translate(150.000000, 103.000000)">
                      <g id="Group-2" transform="translate(298.000000, 2735.000000)">
                        <g id="eye-btn" transform="translate(603.000000, 158.000000)">
                          <g id="eye" transform="translate(16.000000, 10.000000)">
                            <path
                              d="M8,12 C12.707,12 15.744,6.716 15.871,6.492 C16.0423473,6.18789583 16.0427264,5.81645323 15.872,5.512 C15.746,5.287 12.731,0 8,0 C3.245,0 0.251,5.289 0.126,5.514 C-0.0429369167,5.81723244 -0.0421795203,6.18646319 0.128,6.489 C0.254,6.713 3.269,12 8,12 Z M8,2 C10.839,2 13.036,4.835 13.818,6 C13.034,7.166 10.837,10 8,10 C5.159,10 2.962,7.162 2.181,5.999 C2.958,4.835 5.146,2 8,2 Z"
                              id="Shape" fill-rule="nonzero"></path>
                            <circle id="Oval" cx="8" cy="6" r="2"></circle>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
            <button *ngIf="!hidePrivate" type="button" class="btn btn-lg secondary" (click)="click('private')">
              <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>Shape</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Parametrage" transform="translate(-1067.000000, -2954.000000)" fill="#848484"
                    fill-rule="nonzero">
                    <g id="Content" transform="translate(150.000000, 103.000000)">
                      <g id="Group-2" transform="translate(298.000000, 2735.000000)">
                        <g id="eye-btn" transform="translate(603.000000, 108.000000)">
                          <g id="eye-close" transform="translate(16.000000, 8.000000)">
                            <path
                              d="M14.574,5.669 L13.15,7.093 C13.428,7.44 13.656,7.757 13.819,8 C13.059,9.13 10.969,11.82 8.258,11.985 L6.443,13.8 C6.939,13.924 7.457,14 8,14 C12.707,14 15.744,8.716 15.871,8.492 C16.0423473,8.18789583 16.0427264,7.81645323 15.872,7.512 C15.825,7.427 15.372,6.631 14.574,5.669 Z M0.293,15.707 C0.480135129,15.8952092 0.734590365,16.0010349 1,16.0010349 C1.26540963,16.0010349 1.51986487,15.8952092 1.707,15.707 L15.707,1.707 C16.0974653,1.31653468 16.0974653,0.683465318 15.707,0.293 C15.3165347,-0.0974653181 14.6834653,-0.0974653181 14.293,0.293 L11.548,3.038 C10.515,2.431 9.331,2 8,2 C3.245,2 0.251,7.289 0.126,7.514 C-0.0429369167,7.81723244 -0.0421795203,8.18646319 0.128,8.489 C0.198,8.614 1.172,10.291 2.821,11.765 L0.292,14.294 C0.104722311,14.4814896 -0.000388313677,14.7357067 -0.000200769118,15.0007071 C-1.32245582e-05,15.2657076 0.105457121,15.5197757 0.293,15.707 Z M2.181,7.999 C2.958,6.835 5.146,4 8,4 C8.742,4 9.437,4.201 10.078,4.508 L8.512,6.074 C8.34544024,6.02640895 8.17321882,6.00151757 8,6 C6.8954305,6 6,6.8954305 6,8 C6,8.178 6.029,8.348 6.074,8.512 L4.24,10.346 C3.45904071,9.65203252 2.76740147,8.86365114 2.181,7.999 Z"
                              id="Shape"></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
            <button type="button" class="btn btn-lg secondary" (click)="click('newPrivate')">
              <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>Shape</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="UI-Parametrage" transform="translate(-1129.000000, -2953.000000)" fill="#848484"
                    fill-rule="nonzero">
                    <g id="Content" transform="translate(150.000000, 103.000000)">
                      <g id="Group-2" transform="translate(298.000000, 2735.000000)">
                        <g id="refresh-btn" transform="translate(665.000000, 107.000000)">
                          <g id="refresh" transform="translate(16.000000, 8.000000)">
                            <path
                              d="M8,3 C9.179,3 10.311,3.423 11.205,4.17 L8.883,6.492 L15.094,7.031 L14.555,0.82 L12.625,2.75 C11.346905,1.62453622 9.70299416,1.00251588 8,1 C4.57986746,0.989236013 1.65646558,3.45991927 1.097,6.834 L3.07,7.165 C3.46968486,4.7555914 5.55767996,2.99159554 8,3 Z M8,13 C6.82759214,12.9974996 5.69328309,12.5834148 4.795,11.83 L7.117,9.508 L0.906,8.969 L1.445,15.18 L3.375,13.25 C4.65309496,14.3754638 6.29700584,14.9974841 8,15 C11.4201325,15.010764 14.3435344,12.5400807 14.903,9.166 L12.93,8.835 C12.5303151,11.2444086 10.44232,13.0084045 8,13 Z"
                              id="Shape"></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 report-form">
      <span class="column-title">WebHook</span>
      <div class="container">
        <div class="row generalrows">
          <div class="col-4 center">
            <span class="span-txt">Url</span>
          </div>
          <div class="col-7">
            <content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="330" [height]="40">
              <svg:rect id="rect3686" width="330px" height="40px" x="0" y="0" rx="3" ry="3"
                style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
            </content-loader>
          </div>
        </div>
        <div class="row generalrows">
          <div class="col-4 center">
            <span class="span-txt">Header Key</span>
          </div>
          <div class="col-7">
            <content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="330" [height]="40">
              <svg:rect id="rect3686" width="330px" height="40px" x="0" y="0" rx="3" ry="3"
                style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
            </content-loader>
          </div>
        </div>
        <div class="row generalrows">
          <div class="col-3">
            <content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="150" [height]="40">
              <svg:rect id="rect3686" width="150px" height="40px" x="0" y="0" rx="3" ry="3"
                style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
            </content-loader>
          </div>
          <div class="col-3">
            <content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="150" [height]="40">
              <svg:rect id="rect3686" width="150px" height="40px" x="0" y="0" rx="3" ry="3"
                style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
            </content-loader>
          </div>
          <div class="col-3">
            <content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="150" [height]="40">
              <svg:rect id="rect3686" width="150px" height="40px" x="0" y="0" rx="3" ry="3"
                style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
            </content-loader>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 report-form">
      <span class="column-title">Test WebHook</span>
      <div class="container">
        <div class="row generalrows">
          <div class="col-3 center">
            <span i18n="parameters-apiwebhook|@@event_type" class="span-txt">Type d'évènement</span>
          </div>
          <div class="col-7">
            <content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="330" [height]="40">
              <svg:rect id="rect3686" width="330px" height="40px" x="0" y="0" rx="3" ry="3"
                style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
            </content-loader>
          </div>
          <div class="col-2">
            <button type="button" class="btn btn-lg secondary" (click)="testWebhook()">
              <span i18n="parameters-apiwebhook|@@test" class="text-span">Tester</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/element/parameters-apiwebhook/parameters-apiwebhook.component.html